<template>
  <el-row :gutter="20" class="panel-group">
    <el-col :span="7" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-text">
          {{ $t('dashboard.balance') }}
          <el-tooltip v-if="!checkPermission(['ROLE_AUTH_AGENT_ADMIN'])" placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.dashboard_balance_question') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip>
        </div>
        <div class="card-panel-num">{{ $store.getters.currency }} {{ overviewData.total_balance | toDivideWithDot }}
          <el-tooltip placement="bottom">
            <div slot="content">
              <div>
                <span>{{ $t('tips.dashboard_balance_number') }} {{ balanceTooltipData.available_withdraw | toDivideWithDot }} {{ $store.getters.currency }}</span>
              </div>
              <template v-if="balanceTooltipData.nsds_status">
                <div>
                  <span>{{ $t('tips.nsds_balance') }}: {{ balanceTooltipData.nsds_balance | toDivideWithDot }} {{ $store.getters.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('tips.nsds_credit_limit') }}: {{ balanceTooltipData.current_nsds_credit_limit | toDivideWithDot }} {{ $store.getters.currency }}</span>
                </div>
                <div v-if="hasPendingNsdsCreditLimit">
                  <svg-icon icon-class="icon-font-warning" style="color: #F67C7C;" />
                  <span>{{ $t('tips.nsds_credit_limit_pending_prefix') }} {{ balanceTooltipData.pending_nsds_credit_limit | toDivideWithDot }} {{ $store.getters.currency }}{{ $t('tips.nsds_credit_limit_pending_suffix') }}</span>
                </div>
              </template>
            </div>
            <span>  <svg-icon icon-class="icon-font-warning" class="icon-warning" /></span>
          </el-tooltip>
        </div>

      </div>
    </el-col>
    <el-col :span="7" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-text">
          {{ $t('dashboard.in_transit') }}
        </div>
        <div class="card-panel-num">{{ $store.getters.currency }} {{ overviewData.in_transit | toDivideWithDot }}</div>
      </div>

    </el-col>
    <el-col v-if="overviewData.adb_amount" :span="7" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-text">
          {{ $t('dashboard.abd_balance') }}
        </div>
        <div class="card-panel-num">{{ overviewData.adb_amount | toDivideWithDot }}</div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { fetchOverview } from '@/api/dashboard/dashboard.js'
import { fetchMerchantInfo } from '@/api/merchant-manage/merchant-manage'
import serviceConst from '@/const/serviceConst.json'
import { checkPermission } from '@/utils/directive/permission'
export default {
  data() {
    this.checkPermission = checkPermission
    return {
      overviewData: {
        total_balance: 0,
        in_transit: 0
      },
      balanceInfo: {}
    }
  },
  mounted() {
    const { token } = this.$store.getters
    if (token) {
      this.getOverviewData()
      // 无余额权限时不请求 mch/info，避免该接口鉴权失败弹出报错提示
      if (this.hasBalanceAuth) {
        this.getMerchantInfo()
      }
    }
  },
  computed: {
    // 是否拥有余额权限
    hasBalanceAuth() {
      return this.$store.getters.authorities.includes('AUTH_CODE_BALANCE')
    },
    balanceTooltipData() {
      return Object.keys(this.balanceInfo).length ? this.balanceInfo : this.overviewData
    },
    hasPendingNsdsCreditLimit() {
      const limit = this.balanceTooltipData.pending_nsds_credit_limit
      return limit !== undefined && limit !== null && limit !== ''
    }
  },
  methods: {
    getOverviewData() {
      fetchOverview().then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.overviewData = res.data
        }
      })
    },
    getMerchantInfo() {
      fetchMerchantInfo().then(res => {
        const { balance } = res.data || {}
        this.balanceInfo = balance || {}
      })
    },
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  padding-bottom: 32px;
  border-bottom: 1px solid #D3D7DF;
  .icon-warning{
      font-size: 15px;
      position: relative;
      top: -4px;
      cursor: pointer;
      color: #0FFFFF;
    }
  .card-panel-col{
    margin-right: 20px;
    .card-panel {
      position: relative;
      box-sizing: border-box;
      padding: 26px 33px 29px;
      border: 1.5px solid #D3D7DF;
      border-radius: 8px;
      overflow: hidden;
      .card-panel-text {
        font-weight: 500;  font-family: 'Inter-Medium';
        font-size: 14px;
        line-height: 1.2;
        margin-bottom:16px;
      }
      .card-panel-num {
        font-weight: 600;  font-family: 'Inter-SemiBold';
        font-size: 24px;
        line-height: 1.2;
      }
      &::before{
        content: '';
        display: inline-block;
        width: 115px;
        height: 115px;
        border-radius: 50%;
        position: absolute;
        top: -57.5px;
        right: -57.5px;
      }
      &::after{
        content: '';
        display: inline-block;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        position: absolute;
        top: - 35px;
        right: -35px;
      }
    }
    &:nth-child(1) .card-panel {
      background: #1D3A71;
      .card-panel-text {
        color: #FFFFFF;
      }
      .card-panel-num {
        color: #0FFFFF;
      }
      &::before{
        background: rgba(255, 255, 255, 0.2);
      }
      &::after{
        background: #1D3A71;
      }
    }
    &:nth-child(2) .card-panel,
    &:nth-child(3) .card-panel
     {
      background: #fff;
      .card-panel-text {
        color: #1D3A71;
      }
      .card-panel-num {
        color: #3855F1;
      }
      &::before{
        background: #9AB4E5;
      }
      &::after{
        background: #fff;
      }
    }
  }
}
// @media screen and (max-width: 376px) {
//   .panel-group {
//     .card-panel-col {
//       width: 100%;
//     }
//   }
// }
</style>
